// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__2kJwM","Logo":"Toolbar__Logo__113zl","DesktopOnly":"Toolbar__DesktopOnly__r1CMo"};